module.exports = __webpack_public_path__ + "img/indianBanner.663ffb40.jpg";